module.exports = __webpack_public_path__ + "img/ms-pictogram.319d9b9a.svg";